import { useEffect, useRef } from 'react';
import { apiClient } from '../api';
import { getInitialParam } from '../utils/initialParams';
import { IDLE_TERMINATION_PANELS } from '../config/panels';
import { clientLogger } from '../utils/client-logger';

const POLL_INTERVAL_MS = 30_000;

export function usePanelIdleTermination(): void {
  const firedRef = useRef(false);

  useEffect(() => {
    const enabled = IDLE_TERMINATION_PANELS.some((p) =>
      getInitialParam(p.param)
    );
    if (!enabled) return;

    let cancelled = false;

    const check = async () => {
      if (cancelled || firedRef.current) return;
      try {
        const { terminate, url } = await apiClient.checkPanelIdleTermination();
        if (cancelled || firedRef.current) return;
        if (terminate && url) {
          firedRef.current = true;
          clientLogger.info('Panel idle termination redirect', { url });
          window.location.replace(url);
        }
      } catch (error) {
        clientLogger.info('Panel idle check failed', { error });
      }
    };

    const intervalId = window.setInterval(check, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, []);
}
